import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as OneTimePaymentLinkIcon } from '../../../assets/icons/payment-link-one-time.svg';
import { ReactComponent as RecurringPaymentLinkIcon } from '../../../assets/icons/payment-link-recurring.svg';
import { ReactComponent as OpenPaymentLinkIcon } from '../../../assets/icons/payment-link-open.svg';
import { ReactComponent as SmartPaymentIcon } from '../../../assets/icons/smart-payment.svg';
import { ReactComponent as SubscriptionsIcon } from '../../../assets/icons/subscriptions-calendar.svg';
import { ReactComponent as PaymentButtonIcon } from '../../../assets/icons/payment-button-dollar.svg';
import './styles.scss';

interface ChargeOption {
  id: string;
  labelKey: string;
  tooltipKey: string;
  route?: string;
  disabled?: boolean;
  icon: React.ReactNode;
}

const Charges = () => {
  const history = useHistory();

  const options: ChargeOption[] = [
    {
      id: 'one-time-payment-link',
      labelKey: 'menu.subItem.ONE_TIME_PAYMENT_LINK',
      tooltipKey: 'charges.oneTimePaymentLink.tooltip',
      route: Routes.ONE_TIME_PAYMENT_LINK,
      icon: <OneTimePaymentLinkIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'recurring-payment-link',
      labelKey: 'menu.subItem.RECURRING_PAYMENT_LINK',
      tooltipKey: 'charges.recurringPaymentLink.tooltip',
      route: Routes.RECURRING_PAYMENT_LINK,
      icon: <RecurringPaymentLinkIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'open-payment-link',
      labelKey: 'menu.subItem.OPEN_PAYMENT_LINK',
      tooltipKey: 'charges.openPaymentLink.tooltip',
      route: Routes.OPEN_PAYMENT_LINK,
      icon: <OpenPaymentLinkIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'qr-payment',
      labelKey: 'menu.subItem.QR_PAYMENT',
      tooltipKey: 'charges.qrPayment.tooltip',
      route: Routes.QR_PAYMENT,
      icon: <SmartPaymentIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'subscriptions',
      labelKey: 'menu.subItem.SUBSCRIPTIONS',
      tooltipKey: 'charges.subscriptions.tooltip',
      route: Routes.SUBSCRIPTIONS,
      icon: <SubscriptionsIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    // TODO: Pago inteligente aún no existe como producto.
    /*{
      id: 'smart-payment',
      labelKey: 'menu.subItem.SMART_PAYMENT',
      tooltipKey: 'charges.smartPayment.tooltip',
      disabled: true,
      icon: <SmartPaymentIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },*/
    {
      id: 'payment-button',
      labelKey: 'menu.subItem.PAYMENT_BUTTON',
      tooltipKey: 'charges.paymentButton.tooltip',
      route: Routes.PAYMENT_BUTTON,
      icon: <PaymentButtonIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
  ];

  return (
    <div className="charges-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_COBRAR')} subtitle={l('charges.subheadline')} />
      <AlertMessages />
      <Card className="charges-hub__card">
        <div className="charges-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="charges-hub__accent-line" />}>
              <button
                type="button"
                className="charges-hub__item"
                role="listitem"
                disabled={option.disabled}
                onClick={() => option.route && history.push(option.route)}
              >
                <div className="charges-hub__info" onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="charges-hub__info-icon" aria-hidden />}
                  />
                </div>
                <div className="charges-hub__icon-wrap">{option.icon}</div>
                <div className="charges-hub__label">{l(option.labelKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Charges;
